import {
  FileTextIcon,
  LinkIcon,
  SearchIcon,
  SparklesIcon,
  TrendingUpIcon,
  UsersIcon,
} from 'lucide-react'

export const REPORT_SECTIONS = [
  {
    icon: FileTextIcon,
    title: 'Where the Money Went',
    description:
      'Where money came from, which accounts it moved through, and where it went',
  },
  {
    icon: TrendingUpIcon,
    title: 'Income & Transaction Analysis',
    description: 'Deposits, withdrawals, and cash flow patterns over time',
  },
  {
    icon: SearchIcon,
    title: 'Spending Pattern Analysis',
    description:
      'Category breakdowns, recurring expenses, and lifestyle indicators',
  },
  {
    icon: UsersIcon,
    title: 'Related Party Transactions',
    description: 'Payments to known associates, businesses, and third parties',
  },
  {
    icon: LinkIcon,
    title: 'Key Findings & Recommendations',
    description: 'Actionable findings and suggested next steps for your case',
  },
  {
    icon: SparklesIcon,
    title: 'Follow-Up Chat',
    description: 'Ask Daystrom questions about the report after it generates',
  },
]
